export default __webpack_public_path__ + "static/media/whiteCard.0dced47b.svg";